/**
 * @param {string} s
 * @return {string}
 */
export const wrapInParens = (s) => `(${s})`;
